<title>Visio Messaging XML - {{versaoSistema}}</title>
<div class="d-flex">
  <app-menu [usuarioAutenticado]="usuarioAutenticado" class="h-100 no-print col-2 h-100" id="sidebar-menu"></app-menu>

  <div class="d-flex flex-column w-100">
    <app-header class="no-print" [usuarioAutenticado]="usuarioAutenticado" [usuarioLogado]="usuarioLogado"></app-header>
    
    <section class="container-fluid mt-5 py-2 menu-section">
      <router-outlet></router-outlet>
    </section>
    <app-status-carga-loading [usuarioAutenticadoP]="usuarioAutenticado"></app-status-carga-loading>
    <app-toolbar [usuarioAutenticadoP]="usuarioAutenticado" class="no-print"></app-toolbar>
    
  </div>
</div>
<app-sefaz-stripe></app-sefaz-stripe>
<!-- <div [hidden]="sefazPrdHml" class="bg-danger sefaz_stripe text-center align-content-center text-white fs-4">Ambiente Homologação Sefaz</div> -->

<app-loading [show]="apiLoading.loading$ | async"></app-loading>
<app-error-popup></app-error-popup>